<template>
  <div class="footerSubscription">
    <h3 class="footerSubscription__heading">
      Want to keep up with latest legal affairs?
    </h3>
    <Form
      :validation-schema="schema"
      class="footerSubscription__form"
      @submit="onSubmit"
    >
      <div class="footerSubscription__inputFields">
        <div class="footerSubscription__inputGroupWrapper">
          <div class="footerSubscription__inputGroup">
            <img
              src="../../images/user.svg"
              alt="user"
              class="footerSubscription__icon"
            >
            <Field
              id="full_name"
              name="full_name"
              type="text"
              placeholder="Full Name"
            />
          </div>
          <ErrorMessage
            name="full_name"
            class="footerSubscription__form--error"
          />
        </div>
        <div class="footerSubscription__inputGroupWrapper">
          <div class="footerSubscription__inputGroup">
            <img
              src="../../images/envelope.svg"
              alt="user"
              class="footerSubscription__icon"
            >
            <Field
              id="email"
              name="email"
              type="email"
              placeholder="Email Address"
            />
          </div>
          <ErrorMessage
            id="email-error"
            name="email"
            class="footerSubscription__form--error"
          />
        </div>
      </div>
      <SubmitButtonComponent
        :is-loading="loading"
        label="Subscribe Newsletter"
        class="footerSubscription__button"
      />
    </Form>
  </div>
</template>

<script>
import SubmitButtonComponent from '@/components/ButtonComponent/SubmitButtonComponent.vue'
import {Form, Field, ErrorMessage} from 'vee-validate'
import * as yup from 'yup'
import {useSubscriptionStore} from '@/store'
import {alphaSpaceRegex} from '@/utils/constant'
import {computed} from 'vue'


export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    SubmitButtonComponent,
  },
  setup() {
    const schema = yup.object().shape({
      full_name: yup
        .string()
        .matches(alphaSpaceRegex, `The Full Name field may only contain alphabetic characters as well as spaces.`)
        .required((data) => `The ${data.label} field is required.`)
        .label('full name'),
      email: yup
        .string()
        .email('Enter valid email address.')
        .required((data) => `The ${data.path} field is required.`),
    })

    const subscriptionStore = useSubscriptionStore()

    const loading = computed(() => subscriptionStore.loading)

    const onSubmit = async (values, {resetForm}) => {
      await subscriptionStore.createSubscription(values)
      resetForm()
    }
    return {
      loading,
      schema,
      onSubmit,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/module/components/footer-subscription-component';
</style>
